import { render, staticRenderFns } from "./QuadroHorarioSalaEspecial.vue?vue&type=template&id=b410c584&scoped=true&"
import script from "./QuadroHorarioSalaEspecial.vue?vue&type=script&lang=js&"
export * from "./QuadroHorarioSalaEspecial.vue?vue&type=script&lang=js&"
import style0 from "./QuadroHorarioSalaEspecial.vue?vue&type=style&index=0&id=b410c584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b410c584",
  null
  
)

export default component.exports